<script>
    import { token } from "../store/token.js";
    import { user } from "../store/user.js";
    import { section } from "../store/section.js";

    let email;
    let password;
    let error_message;

    const handle_login = async () => {
        const login_response = await fetch(
            //"https://staging.api.control.vollume.com/admin/login",
            `${process.env.API_ROOT}/login`,
            {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                    password,
                    device_type: "web_settings",
                }),
            },
        );

        const response = await login_response.json();

        console.log(response);

        if (response.code) {
            error_message = response.message;
            return;
        }

        token.set(response.token);

        console.log($token);
        console.log(response.user);
        user.set(response.user);

        section.set("account/workspaces");

        return;
    };
</script>

<!--
<div class="pres-container">
    <div class="popup-container">
        <div class="popup-card">
            <h1 class="f-2">Login</h1>

            <div class="w-form">
                <form
                    id="email-form-3"
                    name="email-form-3"
                    data-name="Email Form 3"
                    method="get"
                >
                    <input
                        bind:value={email}
                        type="email"
                        class="field w-input"
                        maxlength="256"
                        name="name"
                        data-name="Name"
                        placeholder="Email"
                        id="name"
                    /><input
                        bind:value={password}
                        type="password"
                        class="field w-input"
                        maxlength="256"
                        name="email-3"
                        data-name="Email 3"
                        placeholder="Password"
                        id="email-3"
                        required=""
                    />
                </form>
                {#if error_message}
                    <div class="w-form-fail">
                        <div>{error_message}</div>
                    </div>{/if}
            </div>
            <div class="popup-actions">
                <div class="button-group-new">
                    <div class="button-group-wrap">
                        <a
                            href="#"
                            class="button button-primary w-button"
                            on:click={() => {
                                try {
                                    handle_login();
                                } catch (e) {
                                    console.log(e);
                                }
                            }}>Login</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
-->
<div class="settings-content">
    <div class="settings-content-holder">
        <div class="text-center">
            <img
                src="../account/images/logo-nav.svg"
                alt="Vollume"
                width="103"
            />
        </div>
    </div>

    <div class="settings-content-holder">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
    </div>

    <div class="settings-content-holder">
        <div class="text-center">
            <h5>Sign in</h5>
        </div>
    </div>

    <div class="settings-content-holder">
        <br />
        <br />
    </div>

    <div class="settings-content-holder">
        <div class="">
            <div class="">
                <div class="card-form-block login-form-holder">
                    <div class="form-group">
                        <input
                            bind:value={email}
                            id="display-name-personal"
                            type="text"
                            name="display-name-personal"
                            placeholder="Email"
                            data-required="true"
                        />
                        <div class="error">Enter a valid email</div>
                    </div>
                    <div class="form-group">
                        <input
                            bind:value={password}
                            id="full-name-personal"
                            type="password"
                            name="full-name-personal"
                            placeholder="Password"
                            data-required="true"
                        />
                        <div class="error">Enter a password</div>
                    </div>

                    {#if error_message}
                        <div class="w-form-fail">
                            <div>{error_message}</div>
                        </div>{/if}

                    <div class="form-group text-md-right">
                        <a
                            class="w-100 btn btn-primary"
                            on:click={() => {
                                try {
                                    handle_login();
                                } catch (e) {
                                    console.log(e);
                                }
                            }}
                            href="#">Login</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="settings-content-holder">
        <br />
    </div>

    <div class="settings-content-holder">
        <div class="text-center">
            <a
                href="#"
                on:click={() => {
                    section.set("public/forgot_password");
                }}
                >Forgot Password?
            </a>
        </div>
    </div>

    <div class="settings-content-holder">
        <br />
        <br />
    </div>

    <div class="settings-content-holder">
        <div class="text-center">
            Don’t have an account? <a
                href="#"
                on:click={() => {
                    section.set("public/signup");
                }}>Sign Up Now</a
            >
        </div>
    </div>

    <!--
    <div class="settings-content-holder">
        <div class="card-personal card">
            <div class="card-body">
                <div class="card-block">
                    <h2 class="h6 card-title">Login</h2>
                </div>
                <div class="card-form-block">
                    <div class="form-group">
                        <input
                            bind:value={email}
                            id="display-name-personal"
                            type="text"
                            name="display-name-personal"
                            placeholder="Email"
                            data-required="true"
                        />
                        <div class="error">Enter a valid email</div>
                    </div>
                    <div class="form-group">
                        <input
                            bind:value={password}
                            id="full-name-personal"
                            type="password"
                            name="full-name-personal"
                            placeholder="Password"
                            data-required="true"
                        />
                        <div class="error">Enter a password</div>
                    </div>

                    {#if error_message}
                        <div class="w-form-fail">
                            <div>{error_message}</div>
                        </div>{/if}

                    <div class="button-holder text-md-right">
                        <a
                            class="btn btn-primary"
                            on:click={() => {
                                try {
                                    handle_login();
                                } catch (e) {
                                    console.log(e);
                                }
                            }}
                            href="#">Login</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
    -->
</div>

<style>
    .login-form-holder {
        max-width: 452px;
        margin: 0 auto;
    }
</style>
